module.exports = __webpack_public_path__ + "static/media/advantage-3.1f5d1a30.png";